'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var gifts = exports.gifts = {
  title: 'Regala',
  background_url: 'https://dev-res.thumbr.io/images/gifts-banner.jpg',
  why: 'Regala un curso y sorprende',
  description: 'Haz un regalo útil y divertido, te garantizamos la sorpresa ;-)',
  cta: 'Encuentra cursos para regalar',
  how_it_works: 'Cómo funciona',
  feats: JSON.stringify(['find', 'wrap', 'notify', 'repeat']),
  find_title: 'Encuentra el curso ideal',
  find_description: 'Piensa en la otra persona y en cómo le podrías ayudar. Elige la temática y el curso, ya sea gratis o de pago. Haz clic en el enlace de “Regalar”',
  find_icon: 'https://lib.tutellus.com/images/icons/find.svg',
  wrap_title: 'Prepara el regalo',
  wrap_description: 'Diseña el regalo, escribe lo que quieras, lo enviaremos por email a la persona que nos digas en la fecha y hora que marques. Esfuérzate!',
  wrap_icon: 'https://lib.tutellus.com/images/icons/compose.svg',
  notify_title: 'Estate atento',
  notify_description: 'Te avisaremos en el preciso momento de enviar el regalo. La otra persona recibirá un mail con tu regalo y un cupón para poder apuntarse al curso.',
  notify_icon: 'https://lib.tutellus.com/images/icons/notification.svg',
  repeat_title: '¡Repite!',
  repeat_description: 'Regalar, como ayudar a los demás, engancha. Puedes regalar tantos cursos como quieras, y a tantas personas como los necesiten.',
  repeat_icon: 'https://lib.tutellus.com/images/icons/gift.svg'
};


//////////////////
// WEBPACK FOOTER
// ../i18n/lib/es/gifts.js
// module id = 698
// module chunks = 0